import { render, staticRenderFns } from "./TasksEvent.vue?vue&type=template&id=7c550a00&scoped=true"
import script from "./TasksEvent.vue?vue&type=script&lang=ts"
export * from "./TasksEvent.vue?vue&type=script&lang=ts"
import style0 from "./TasksEvent.vue?vue&type=style&index=0&id=7c550a00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c550a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c550a00')) {
      api.createRecord('7c550a00', component.options)
    } else {
      api.reload('7c550a00', component.options)
    }
    module.hot.accept("./TasksEvent.vue?vue&type=template&id=7c550a00&scoped=true", function () {
      api.rerender('7c550a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/TasksEvent.vue"
export default component.exports